export enum SCENE_STATUS {
  ACTIVE,
  FADE_IN,
  FADE_OUT,
}
